import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import Nav from './nav'
import { createStore, applyMiddleware,combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { Provider, connect } from 'react-redux'
import {timelineReducer,loadDataAction} from './TimelineReducer';
import {poetsReducer} from './PoetsReducer';
import {poemsReducer} from './PoemsListReducer';

function loadPoems() {
    return (dispatch, getState)=> {return ({type:'SHOW_POEMS_LOADING'}); };
    // setTimeout((dispatch) =>{dispatch({type:'POPULATE_POEMS_DATA'})}, 1000 );
}


const store = createStore(
    combineReducers({ poets: poetsReducer, timeline:timelineReducer, poems: poemsReducer}),
    applyMiddleware(thunk)
  );
  

class App extends React.Component {
    render(){
        return <Provider store={store}>
        <Nav/>
        </Provider>
    }
}


// import PoemDialog from './PoemDialog'
ReactDOM.render(<App/>, document.getElementById('root'));
// ReactDOM.render(<PoemDialog poemId={76} />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js